<script>
const { VUE_APP_API_HOST } = process.env

export default {
  methods: {
    listApiKeys() {
      return this.$http
        .get(`${VUE_APP_API_HOST}/api-keys`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(res => res, err => err)
    },

    createApiKey(body) {
      return this.$http
        .post(`${VUE_APP_API_HOST}/api-keys`,
          body,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }
        )
        .then(res => res, err => err)
    },

    updateApiKey(id, body) {
      return this.$http
        .put(`${VUE_APP_API_HOST}/api-keys/${id}`,
          body,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }
        )
        .then(res => res, err => err)
    },

    revokeApiKey(id) {
      return this.$http
        .delete(`${VUE_APP_API_HOST}/api-keys/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(res => res, err => err)
    },

    // OAuth "remote connector" flow (see engine's controllers/oauth.js): creating the key here
    // *is* the authorization step, this just also ties the new key to the pending OAuth request
    // and returns the URL to redirect back to the connecting client (e.g. Claude).
    completeOAuthApiKey(flowId, body) {
      return this.$http
        .post(`${VUE_APP_API_HOST}/oauth/complete`,
          { flow_id: flowId, ...body },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }
        )
        .then(res => res, err => err)
    }
  }
}
</script>
